import React from 'react'
import { Box, Dialog, IconButton, makeStyles, useMediaQuery, useTheme } from '@material-ui/core'
import Slide from '@material-ui/core/Slide'
import CustomHeading from './CustomHeading'
import { MdCancel } from 'react-icons/md'
import { Close } from '@material-ui/icons'
import HeadingWithCloseIcon from './HeadingWithCloseIcon'

const useStyles = makeStyles((theme) => ({
  content: {
    padding: '30px',

    // [theme.breakpoints.up('md')]: {
    //   padding: '40px 20px 30px 40px',
    // },
  },

  rounded: {
    borderRadius: '10px',
    [theme.breakpoints.up('md')]: {
      minWidth: '705px',
    },
    [theme.breakpoints.up('lg')]: {
      minWidth: '600px',
    },
  },
  scrollBar: {
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: '2px',
    },

    /* Track */
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px #d4d4d4',
      borderRadius: '10px',
    },

    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#717171',
      borderRadius: '10px',
      '&:hover': {
        background: '#ddd',
      },
    },
  },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})

export default function CustomDialog({ children, open, handleClose, className, scroll, fullScreen, noPadding, heading }) {
  const theme = useTheme()

  const classes = useStyles()
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      maxWidth="sm"
      classes={{ paper: className ? ` ${classes.rounded} ${classes.scrollBar} ${className}` : classes.rounded }}
      fade
      scroll={scroll}
      fullScreen={fullScreen}
    >
      {/* <Box display="flex" justifyContent="flex-end">
        <Close />
      </Box> */}
      <div className={noPadding ? '' : classes.content}>
        {heading && <HeadingWithCloseIcon heading={heading} handleClose={handleClose} />}
        {children}
      </div>
    </Dialog>
  )
}
